var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 6.6C11.7225 6.6 13.2 5.12254 13.2 3.3C13.2 1.47746 11.7225 0 9.9 0C8.07746 0 6.6 1.47746 6.6 3.3C6.6 5.12254 8.07746 6.6 9.9 6.6Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5C5.5 6.71503 4.51503 7.7 3.3 7.7C2.08497 7.7 1.1 6.71503 1.1 5.5C1.1 4.28497 2.08497 3.3 3.3 3.3C4.51503 3.3 5.5 4.28497 5.5 5.5Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.539708 13.5582C0.353172 13.4498 0.209234 13.279 0.145715 13.0728C0.0509918 12.7653 0 12.4386 0 12.1C0 10.2775 1.47746 8.8 3.3 8.8C3.8742 8.8 4.41415 8.94665 4.88444 9.20455C3.73262 10.3387 2.96355 11.8608 2.78826 13.5594C2.76298 13.8043 2.77353 14.0461 2.81596 14.279C1.99167 14.2071 1.21948 13.9534 0.539708 13.5582Z",
    fill: "#232323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9845 14.279C17.8086 14.207 18.5807 13.9533 19.2603 13.5582C19.4468 13.4498 19.5908 13.279 19.6543 13.0728C19.749 12.7653 19.8 12.4386 19.8 12.1C19.8 10.2775 18.3225 8.8 16.5 8.8C15.9259 8.8 15.3861 8.94659 14.9159 9.20438C16.0678 10.3386 16.8369 11.8607 17.0122 13.5594C17.0375 13.8043 17.0269 14.0461 16.9845 14.279Z",
    fill: "#232323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 5.5C18.7 6.71503 17.715 7.7 16.5 7.7C15.285 7.7 14.3 6.71503 14.3 5.5C14.3 4.28497 15.285 3.3 16.5 3.3C17.715 3.3 18.7 4.28497 18.7 5.5Z",
    fill: "#232323"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73422 14.51C4.5152 14.3117 4.39914 14.0226 4.42947 13.7288C4.71523 10.9596 7.05549 8.8 9.90016 8.8C12.7448 8.8 15.0851 10.9596 15.3708 13.7288C15.4012 14.0226 15.2851 14.3117 15.0661 14.51C13.7 15.7467 11.888 16.5 9.90016 16.5C7.91228 16.5 6.10033 15.7467 4.73422 14.51Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.9dfb9081f3f22d00e54104a4956133ba.svg";
export { ForwardRef as ReactComponent };